import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { generateOtp, generateMobOtp, verifyOtp, verifymobOtp } from "../configs/WebService";
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
import { setAppdAiGuest } from "../utils/appdAiHelpers";
import { handleUserData, setAuthData } from "../auth/authSlice";
import userStore from "../zustand/userStore";
import { useDispatch } from "react-redux";
import {
  sendWelcomeEmail,
  sendWelcomeSMS,
  sendWelcomeTemplate,
} from "../features/student/redux/studentThunk";
import AudioToggleButton from "../components/AudioToggleButton";
// Replace this with your actual API endpoint
const WSVerifyOTP = "https://your-domain.com/api/verify-otp";

const OtpVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasInitialized = useRef(false);
  const audioRef = useRef(null);

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [step, setStep] = useState("email"); // "email" or "mobile"
  const [userPayload, setUserPayload] = useState(null); // Full payload from signup
  const payload = location.state?.formData;
  const source = location.state?.source;
  const isWhatsapp = location.state?.isWhatsapp;
  const isEmailSuccessful = location.state?.isEmailSuccessful;
  const isSMS = location.state?.isSMS;
  const signupPayload = location.state?.notificationPayload || location.state?.formData;
  const phone = payload?.contactNumber || payload?.contact_number;
  const setUser = userStore.getState().setUser;

  // console.log("signupPayload", signupPayload)

  const otpAudioTimers = useRef([]);

  const stopAudio = () => {
    otpAudioTimers.current.forEach((t) => clearTimeout(t));
    otpAudioTimers.current = [];
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  useEffect(() => {
    setAppdAiGuest("registration");
  }, []);

  // Auto-play otp audio: play 0-14, pause 10s, then play 14-end
  useEffect(() => {
    const audio = new Audio("/audio/Registration page/Script 4a — mdm_otp_sent_v1.mp3");
    audioRef.current = audio;
    audio.play().catch(() => {});

    // Pause at 14 seconds
    const pauseTimer = setTimeout(() => {
      if (!audio.paused && !audio.ended) {
        audio.pause();
      }
    }, 14000);
    otpAudioTimers.current.push(pauseTimer);

    // Resume from 14s after 10s delay (at 24s total)
    const resumeTimer = setTimeout(() => {
      if (audioRef.current === audio) {
        audio.currentTime = 14;
        audio.play().catch(() => {});
      }
    }, 24000);
    otpAudioTimers.current.push(resumeTimer);

    return () => {
      otpAudioTimers.current.forEach((t) => clearTimeout(t));
      otpAudioTimers.current = [];
      audio.pause();
      audio.currentTime = 0;
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    // 2. Only run the logic if it hasn't run before and state exists
    if (hasInitialized.current || !location.state) return;
    if (source === "login") {
      if (payload?.email && !phone) {
        setEmail(payload.email);
        setMobile("");
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      } else if (phone && !payload?.email) {
        setStep("mobile");
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToMobile(phone);
        hasInitialized.current = true; // Mark as done
      } else if (payload?.email && phone) {
        setEmail(payload.email);
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      }
    } else {
      // Signup Logic
      if (payload?.email && phone) {
        setEmail(payload.email);
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      } else {
        alert("No user data found. Redirecting...");
        stopAudio();
        navigate("/signup");
      }
    }
  }, [location, navigate]);

  const sendOtpToMobile = async (mobileNumber) => {
    try {
      const response = await fetch(generateMobOtp, { // Using your mobile config
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otpType: "mobile", otpSentTo: mobileNumber }), // Ensure your backend expects 'to'
      });

      if (response.ok) {
        console.log("OTP sent successfully to mobile:", mobileNumber);
        document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'sent' } }));
        alert("Now, an OTP has been sent to your mobile.");
      } else {
        alert("Email verified, but failed to send Mobile OTP. Please use Resend.");
      }
    } catch (error) {
      console.error("Mobile OTP error:", error);
    }
  };

  const sendOtpToEmail = async (email) => {
    try {
      const response = await fetch(generateOtp, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ to: email, otpType: "email_verify" }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("OTP sent successfully to:", email);
        document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'sent' } }));
      } else {
        console.error("OTP send error:", data?.error || "Unknown error");
        alert("Failed to send OTP: " + (data?.error || "Please try again."));
      }
    } catch (error) {
      console.error("Network error while sending OTP:", error);
      alert("Network error. Please try again later.");
    }
  };


  // const handleVerifyOtp = async (e) => {
  //   e.preventDefault();

  //   if (!otp) {
  //     alert("Please enter the OTP.");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const response = await fetch(verifyOtp, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         to: step==="email" ? email:mobile,
  //         otp:otp,
  //       }),
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       alert(`✅ ${step === "email" ? "Email" : "Mobile"} OTP Verified Successfully!`);
  //       setOtp(""); // clear input

  //       if (step === "email") {
  //         //navigate("/login");
  //         setStep("mobile"); //uncomment for mobile otp
  //         sendOtpToMobile(mobile);
  //       }else{
  //         navigate("/login");
  //       }

  //     } else {
  //       alert("❌ Invalid OTP: " + (data?.error || "Please try again."));
  //     }
  //   } catch (error) {
  //     console.error("OTP verification error:", error);
  //     alert("Network error during OTP verification.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp) {
      alert("Please enter the OTP.");
      return;
    }

    setLoading(true);

    // 1. Determine which API and Payload to use based on the current step
    const apiUrl = step === "email" ? verifyOtp : verifymobOtp; // Update with your actual full mobile verify URL

    const payload = step === "email"
      ? { to: email, otp: otp, otpType: "email_verify" }
      : { to: mobile, otp: otp }; // Mobile usually expects 'otpSentTo' based on your previous thunk

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("data_182", data)

      if (response.ok) {
        if (step === "email") {
          // --- EMAIL SUCCESS ---
          document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'verified' } }));
          alert("✅ Email Verified!");
          setOtp("");
          if (phone) {
            setStep("mobile"); // This updates your UI text automatically               
            await sendOtpToMobile(mobile);
          } else {
            stopAudio();
            navigate("/login");
          }
        } else {
          // --- MOBILE SUCCESS ---
          document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'verified' } }));

          // Send notifications after mobile verification
          const notifications = [];
          if (isWhatsapp === 1) {
            notifications.push(dispatch(sendWelcomeTemplate(signupPayload)).unwrap());
          }
          if (isEmailSuccessful === 1) {
            notifications.push(dispatch(sendWelcomeEmail(signupPayload)).unwrap());
          }
          if (isSMS === 1) {
            notifications.push(dispatch(sendWelcomeSMS(signupPayload)).unwrap());
          }
          if (notifications.length > 0) {
            try {
              await Promise.all(notifications);
            } catch (notifyError) {
              console.error("Notification sending error:", notifyError);
            }
          }

          alert("✅ Mobile verified successfully! Your registration process is completed.");
          dispatch(setAuthData(data));
          setUser(data.user);
          // navigate("/login");
          stopAudio();
          navigate("/paywall");
        }
      } else {
        alert("❌ Verification Failed: " + (data?.message || data?.error || "Invalid OTP"));
      }
    } catch (error) {
      console.error("Verification Error:", error);
      alert("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    setLoading(true);

    try {
      // 1. Determine which URL to hit
      const targetApi = step === "email" ? generateOtp : generateMobOtp;

      // 2. Prepare the correct payload for each step
      const payload = step === "email"
        ? { to: email, otpType: "email_verify" }
        : { otpType: "mobile", otpSentTo: mobile };

      const response = await fetch(targetApi, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'sent' } }));
        alert(`OTP resent successfully to your ${step === "email" ? "Email" : "Mobile"}.`);
      } else {
        alert("Failed to resend OTP: " + (data.error || "Please try again later."));
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
      alert("Network error during OTP resend.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelVerification = () => {
    const confirmCancel = window.confirm("Are you sure you want to quit verification?");
    if (confirmCancel) {
      stopAudio();
      navigate("/signup"); // 🔁 or any route where you want to send the user
    }
  };

  return (
    <>
    <AudioToggleButton audioRef={audioRef} />
    <div
      style={{
        maxWidth: "400px",
        margin: "2rem auto",
        padding: "2rem",
        border: "1px solid #ccc",
        borderRadius: "8px",
      }}
    >
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleCancelVerification}
          style={{ fontSize: "0.5rem" }}
        ></button>
      </div>

      <p className="mb-4 text-center">Verify {step === "email" ? "Email" : "Mobile"}</p>
      <p className="text-center">
        Enter the OTP sent to <strong>{step === "email" ? email : mobile}</strong>
      </p>

      <form onSubmit={handleVerifyOtp}>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Enter  OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            maxLength={10}
          />
        </div>

        <button type="submit" className="btn btn-success w-100" disabled={loading}>
          {loading ? "Verifying..." : "Verify OTP"}
        </button>
      </form>

      <div className="text-center mt-3">
        <button className="btn btn-link" onClick={handleResendOtp} disabled={loading}>
          Resend OTP
        </button>
      </div>
    </div>
    </>
  );
};

export default OtpVerification;
